import { render } from "./xtx-button.vue?vue&type=template&id=46eedb2c&scoped=true"
import script from "./xtx-button.vue?vue&type=script&lang=js"
export * from "./xtx-button.vue?vue&type=script&lang=js"

import "./xtx-button.vue?vue&type=style&index=0&id=46eedb2c&scoped=true&lang=less"

import exportComponent from "D:\\hbuilderxpro\\jxshop\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46eedb2c"]])

export default __exports__